module.exports = __webpack_public_path__ + "img/area6_211021.e1c3875b.jpg";